module.exports = __webpack_public_path__ + "static/media/bike2e.f054d398.jpg";